import { useEffect, useState } from 'react';
import './TubeList.scss';
import { FetchData } from '../../utils/FetchData'

export function TubeList () {
    const [list, setList] = useState<Array<any>>([]);

    const fetchTubeList = () => {
        FetchData('youtube/list').
         then((data) =>
            setList(data.response)
         ).catch((e) => console.error(e));
    }
  
    useEffect(() => {
      fetchTubeList();
    }, []);

    return (
        <div className="tube-list">
            <h2><i className="fab fa-youtube"></i> YouTube</h2>

            <ul className="list to-rows-mobile">
                { list.map((item, index) => (
                    <li className="item" key={index}>
                        <a href={item.link} 
                            title={item.title} 
                            style={{backgroundImage: `url(${item.thumbnail})`}}
                            target="_blank"
                            >
                            <h3>{item.title}</h3>

                            <i className="fab fa-youtube"></i>
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );

}